module.exports = "/packs/join_slack-b5e292c62db63923363ea533b4d355c7.png";